import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
  API_INITIAL_STATE,
  BUILDER_TYPE_FULFILLED,
  BUILDER_TYPE_PENDING,
  SLICE_PROVIDER_REQUESTS,
  THUNK_GET_PROVIDER_REQUESTS,
} from "../Constants/SliceAndThunkConstants";
import { apiSliceBuilderService } from "../Services/CommonServices";
import { getProviderRequestsService } from "../Services/ProviderRequestService";
import { STATUS_PENDING } from "../Constants/CommonConstants";

const initialState = {
  unreadProviderRequestsCount: 0,
  getProviderRequestsResponse: API_INITIAL_STATE,
};

export const getProviderRequests = createAsyncThunk(
  `${SLICE_PROVIDER_REQUESTS}/${THUNK_GET_PROVIDER_REQUESTS}`,
  async () => {
    const requestPayload = {
      paginationDto: {
        pageNumber: 0,
        recordsPerPage: 25,
      },
      statusList: [STATUS_PENDING],
      fetchOverrideEligRequestList: false,
    };
    const response = await getProviderRequestsService(requestPayload);
    return response;
  }
);

export const providerRequests = createSlice({
  name: SLICE_PROVIDER_REQUESTS,
  initialState,
  reducers: {
    clearProviderRequestsApiResponse: (state, action) => {
      const responseName = `${action.payload}Response`;
      if (!initialState[responseName]) {
        return;
      }
      state[responseName] = API_INITIAL_STATE;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getProviderRequests.pending, (state) => {
      state.getProviderRequestsResponse =
        apiSliceBuilderService(BUILDER_TYPE_PENDING);
    });

    builder.addCase(getProviderRequests.fulfilled, (state, action) => {
      state.getProviderRequestsResponse = apiSliceBuilderService(
        BUILDER_TYPE_FULFILLED,
        action
      );
      if (!action?.meta?.arg?.fetchNotification) {
        state.unreadProviderRequestsCount =
          action?.payload?.data?.data?.page?.metadata?.totalRecords;
      }
    });
  },
});

export const { clearProviderRequestsApiResponse } = providerRequests.actions;

export default providerRequests.reducer;
